import { useEffect } from 'react';
import { useLocation } from 'ice';
import { EventEmitter } from 'events';
import { useStore } from '@/store';
import { ClientHostType, DEVICE_TYPE, ROUTER_MAP } from '@/types';
import { useEffectDiff } from './useEffectDiff';
export const eventEmitter = new EventEmitter();

export const showSideBarRouterListMap = {
    [ClientHostType.icirena]: [ROUTER_MAP.HOME, ROUTER_MAP.SCREEN, ROUTER_MAP.FILM, ROUTER_MAP.ACTIVITY_AND_VIP, ROUTER_MAP.ACTIVITY_DETAIL],
    [ClientHostType.acx]: [ROUTER_MAP.HOME, ROUTER_MAP.SCREEN, ROUTER_MAP.FILM, ROUTER_MAP.ACTIVITY_AND_VIP, ROUTER_MAP.ACTIVITY_DETAIL],
    [ClientHostType.galaxy]: [],
};


// 自定义钩子
const useSideBar = () => {
    const location = useLocation();
    const { showSideBar, setShowSideBar: set, device, channel } = useStore();
    useEffect(() => {
        if (device === DEVICE_TYPE.PC) {
            // 首页 //影片页有
            if (showSideBarRouterListMap[channel]?.includes(location.pathname as ROUTER_MAP)) {
                set(true);
            } else {
                set(false);
            }
        }
    }, [location]);

    useEffectDiff((n, o) => {
        if (n === o) {
            return;
        }
        if (o === DEVICE_TYPE.PC) {
            set(false);
        } else {
            // 首页 //影片页有
            if (showSideBarRouterListMap[channel]?.includes(location.pathname as ROUTER_MAP) && n === DEVICE_TYPE.PC) {
                set(true);
            } else {
                set(false);
            }
        }
    }, [device]);


    const setShowSideBar = (status?: boolean) => {
        const newStatus = status ?? !showSideBar;
        set(newStatus);
    };


    return {
        showSideBar,
        setShowSideBar,
    };
};

export default useSideBar;
